export function dealError(behavior: string, error): string {
  let errorMessage = '';
  if (error?.error?.error?.message && error.error.error.message !== 'Your request is not valid!'
  && error.error.error.message !== 'An internal error occurred during your request!') {
    errorMessage = error.error.error.message;
  } else {
    switch (error.status) {
      case 500:
        errorMessage = '服务器请求出错';
        break;
      case 400:
        errorMessage = '数据验证失败';
        break;
      case 401:
        errorMessage = '权限不足';
        break;
      case 403:
        errorMessage = '请求被拒绝';
        break;
      case 404:
        errorMessage = '请求数据不存在';
        break;
    }
  }
  const details = getValidationErrors(error);
  return behavior + '失败' + (errorMessage !== '' ? ('，' + errorMessage) : '') + (details !== '' ? ('<br/>' + details) : '');
}

function getValidationErrors(error) {
  const errors = [];
  if (error.error?.error?.validationErrors) {
    for (const err of error.error.error.validationErrors) {
      errors.push('- ' + err.message);
    }
  }
  return errors.join('，');
}
